var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 24,
    viewBox: "0 0 138 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_509_594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z",
    fill: "#006FCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.971 10.268L9.745 12.144H8.203L8.971 10.268ZM25.046 10.346H22.069V11.173H24.998V12.412H22.075V13.334H25.052V14.073L27.129 11.828L25.052 9.488L25.046 10.346ZM10.983 8.006H14.978L15.865 9.941L16.687 8H27.057L28.135 9.19L29.25 8H34.013L30.494 11.852L33.977 15.68H29.143L28.065 14.49L26.94 15.68H10.03L9.536 14.49H8.406L7.911 15.68H4L7.286 8H10.716L10.983 8.006ZM19.646 9.084H17.407L15.907 12.62L14.282 9.084H12.06V13.894L10 9.084H8.007L5.625 14.596H7.18L7.674 13.406H10.27L10.764 14.596H13.484V10.661L15.235 14.602H16.425L18.165 10.673V14.603H19.623L19.647 9.083L19.646 9.084ZM28.986 11.852L31.517 9.084H29.695L28.094 10.81L26.546 9.084H20.652V14.602H26.462L28.076 12.864L29.624 14.602H31.499L28.986 11.852Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_509_594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M85 0H53C51.3 0 50 1.3 50 3V21C50 22.7 51.4 24 53 24H85C86.7 24 88 22.7 88 21V3C88 1.3 86.6 0 85 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 1C86.1 1 87 1.9 87 3V21C87 22.1 86.1 23 85 23H53C51.9 23 51 22.1 51 21V3C51 1.9 51.9 1 53 1H85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 19C68.866 19 72 15.866 72 12C72 8.13401 68.866 5 65 5C61.134 5 58 8.13401 58 12C58 15.866 61.134 19 65 19Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73 19C76.866 19 80 15.866 80 12C80 8.13401 76.866 5 73 5C69.134 5 66 8.13401 66 12C66 15.866 69.134 19 73 19Z",
    fill: "#F79E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 12C72 9.60005 70.8 7.50005 69 6.30005C67.2 7.60005 66 9.70005 66 12C66 14.3 67.2 16.5 69 17.7C70.8 16.5 72 14.4 72 12Z",
    fill: "#FF5F00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_509_594)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M135 0H103C101.3 0 100 1.3 100 3V21C100 22.7 101.4 24 103 24H135C136.7 24 138 22.7 138 21V3C138 1.3 136.6 0 135 0Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135 1C136.1 1 137 1.9 137 3V21C137 22.1 136.1 23 135 23H103C101.9 23 101 22.1 101 21V3C101 1.9 101.9 1 103 1H135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.3 10.1H128C127.6 11.1 127.3 11.6 127 13.1H128.9C128.6 11.6 128.6 10.9 128.3 10.1ZM131.2 16H129.5C129.4 16 129.4 16 129.3 15.9L129.1 15L129 14.8H126.6C126.5 14.8 126.4 14.8 126.4 15L126.1 15.9C126.1 16 126 16 126 16H123.9L124.1 15.5L127 8.7C127 8.2 127.3 8 127.8 8H129.3C129.4 8 129.5 8 129.5 8.2L130.9 14.7C131 15.1 131.1 15.4 131.1 15.8C131.2 15.9 131.2 15.9 131.2 16ZM117.8 15.7L118.2 13.9C118.3 13.9 118.4 14 118.4 14C119.1 14.3 119.8 14.5 120.5 14.4C120.7 14.4 121 14.3 121.2 14.2C121.7 14 121.7 13.5 121.3 13.1C121.1 12.9 120.8 12.8 120.5 12.6C120.1 12.4 119.7 12.2 119.4 11.9C118.2 10.9 118.6 9.5 119.3 8.8C119.9 8.4 120.2 8 121 8C122.2 8 123.5 8 124.1 8.2H124.2C124.1 8.8 124 9.3 123.8 9.9C123.3 9.7 122.8 9.5 122.3 9.5C122 9.5 121.7 9.5 121.4 9.6C121.2 9.6 121.1 9.7 121 9.8C120.8 10 120.8 10.3 121 10.5L121.5 10.9C121.9 11.1 122.3 11.3 122.6 11.5C123.1 11.8 123.6 12.3 123.7 12.9C123.9 13.8 123.6 14.6 122.8 15.2C122.3 15.6 122.1 15.8 121.4 15.8C120 15.8 118.9 15.9 118 15.6C117.9 15.8 117.9 15.8 117.8 15.7ZM114.3 16C114.4 15.3 114.4 15.3 114.5 15C115 12.8 115.5 10.5 115.9 8.3C116 8.1 116 8 116.2 8H118C117.8 9.2 117.6 10.1 117.3 11.2C117 12.7 116.7 14.2 116.3 15.7C116.3 15.9 116.2 15.9 116 15.9M105 8.2C105 8.1 105.2 8 105.3 8H108.7C109.2 8 109.6 8.3 109.7 8.8L110.6 13.2C110.6 13.3 110.6 13.3 110.7 13.4C110.7 13.3 110.8 13.3 110.8 13.3L112.9 8.2C112.8 8.1 112.9 8 113 8H115.1C115.1 8.1 115.1 8.1 115 8.2L111.9 15.5C111.8 15.7 111.8 15.8 111.7 15.9C111.6 16 111.4 15.9 111.2 15.9H109.7C109.6 15.9 109.5 15.9 109.5 15.7L107.9 9.5C107.7 9.3 107.4 9 107 8.9C106.4 8.6 105.3 8.4 105.1 8.4L105 8.2Z",
    fill: "#142688"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_509_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_509_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "white",
    transform: "translate(50)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_509_594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 24,
    fill: "white",
    transform: "translate(100)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcons);
export default __webpack_public_path__ + "static/media/card-icons.aeaf847663e3041394b2127bd2dd1965.svg";
export { ForwardRef as ReactComponent };